import { AppStateEnum } from '../../../../../main/types/app-state.types.ts';

import { selectCurrentLessonTaskStepKey } from '../../../../selectors/current-lesson-task-step-key.selector.ts';
import { updateAppStateThunk } from '../../../../slices/app-state/thunks/update-app-state.thunk.ts';
import { setBallIsVisible } from '../../../../slices/ball/ball.slice.ts';
import { completeStepThunk } from '../../../../slices/progress/thunks/complete-step.thunk.ts';
import { computeStepWordIndicesThunk } from '../../../../slices/story-reading/thunks/compute-step-word-indices.thunk.ts';

import { BaseAppStateChangeHandlerUtil } from '../base-app-state-change.handler.ts';

export class StoryAppReadSentenceStateChangeHandlerUtil extends BaseAppStateChangeHandlerUtil {
  private static _instance: StoryAppReadSentenceStateChangeHandlerUtil;

  public static get instance(): StoryAppReadSentenceStateChangeHandlerUtil {
    if (!StoryAppReadSentenceStateChangeHandlerUtil._instance) {
      StoryAppReadSentenceStateChangeHandlerUtil._instance = new StoryAppReadSentenceStateChangeHandlerUtil();
    }
    return StoryAppReadSentenceStateChangeHandlerUtil._instance;
  }

  protected getHandlerName(): string {
    return 'StoryAppReadSentence';
  }

  protected override async onReadyToStart(): Promise<void> {
    await super.onReadyToStart();
    console.log(`${this.getHandlerName()} onReadyToStart`);
    await this.handleStartStep();
  }

  protected override async onRetry(): Promise<void> {
    await super.onRetry();
    console.log(`${this.getHandlerName()} onRetry`);
    await this.handleStartStep();
  }

  protected override async onPlaying(): Promise<void> {
    try {
      console.log(`${this.getHandlerName()} onPlaying`);
      const dispatch = await this.reduxStoreUtil.getDispatch();
      await this.handleAppReadSentenceWhileAnimatingBall();
      await dispatch(completeStepThunk()).unwrap();
      dispatch(updateAppStateThunk({ state: AppStateEnum.ReadyForNextStep }));
    } catch (error) {
      console.error('Error in StoryAppReadSentence onPlaying', error);
      this.handleError(error as Error);
    }
  }

  protected override async onRecording(): Promise<void> {
    await this.handleInvalidState();
  }

  protected override async onCorrect(): Promise<void> {
    await this.handleInvalidState();
  }

  protected override async onIncorrect(): Promise<void> {
    await this.handleInvalidState();
  }

  protected override async onReadyForNextStep(): Promise<void> {
    console.log(`${this.getHandlerName()} onReadyForNextStep`);
    const dispatch = await this.reduxStoreUtil.getDispatch();
    this.resetBallPosition();

    const state = await this.reduxStoreUtil.getRootState();
    const stepKey = selectCurrentLessonTaskStepKey(state);
    if (this.lessonsUtil.isFinalStep(stepKey)) {
      await this.audioPlayerUtil.speakStep();
      await this.audioPlayerUtil.waitSpeakCompletion();

      dispatch(setBallIsVisible(true));
    } else {
      await dispatch(updateAppStateThunk({ state: AppStateEnum.MoveToNextStep }));
    }
  }

  // Helper methods

  private async handleStartStep(): Promise<void> {
    const dispatch = await this.reduxStoreUtil.getDispatch();

    await dispatch(computeStepWordIndicesThunk()).unwrap();
    await this.audioPlayerUtil.speakStep();
    await this.audioPlayerUtil.waitSpeakCompletion();

    // Show ball when ready
    dispatch(setBallIsVisible(true));
  }
}

export const getStoryAppReadSentenceStateChangeHandlerUtil = (): StoryAppReadSentenceStateChangeHandlerUtil =>
  StoryAppReadSentenceStateChangeHandlerUtil.instance;
